import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-detection_construction",
  "use": "icon-detection_construction-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-detection_construction\"><path d=\"M372.3 64h280.3v224H372.3zM96 792h168.2v168H96zm332.4 0h168.2v168H428.4zm331.4 0H928v168H759.8zM208.1 511h272.4v220h64V511h272.4v220h64V447H544.5V339h-64v108H144.1v284h64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol